import React, { useState, useEffect } from "react";
import config, { API_PKI } from "../../config";
import { useTranslation } from "react-i18next";
import PageWrapper from "../../component/PageWrapper";
const NMUserSuccess = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper title={t("SDKUserForm.successTitle")}>
  <p>
    {t("NCALayerModuleForm.nmUserSuccess")}
  </p>
</PageWrapper>
  );
};

export default NMUserSuccess;
